export default __webpack_public_path__ + "static/media/frontpage.186f8256.txt";